module.exports = __webpack_public_path__ + "static/media/image_keyword_05.1fef8644.webp";